module.exports = __webpack_public_path__ + "videos/jazzy-smoke.598b606.mp4";